<template lang="pug">
    .animation(ref='animation')
        .shield
            svg(width='288' height='366' viewBox='0 0 288 366' fill='none' xmlns='http://www.w3.org/2000/svg')
                path(d='M144.048 16.7354L17.1748 73.617C17.1748 73.617 21.1965 283.112 144.048 343.712C266.9 283.205 270.826 73.617 270.826 73.617L144.048 16.7354Z' fill='#FF0000')
                path(ref='outline' d='M1.52688 65.4556L144.054 1.64358L286.474 65.4555C286.461 65.8679 286.443 66.4063 286.417 67.0653C286.351 68.7746 286.235 71.2947 286.039 74.5287C285.646 80.9971 284.929 90.3206 283.634 101.726C281.042 124.539 276.138 155.663 266.89 188.917C248.43 255.292 212.771 329.761 144.055 363.922C75.3378 329.709 39.6513 255.238 21.1641 188.876C11.9022 155.63 6.98467 124.515 4.38331 101.71C3.08284 90.3092 2.36174 80.9894 1.96584 74.5237C1.7679 71.291 1.65127 68.772 1.58418 67.0635C1.55834 66.4054 1.53985 65.8676 1.52688 65.4556Z' stroke='#FF0000' stroke-width='3')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';
export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline();
            this.timeline
                .set(this.$refs.outline, {scale: 0.95, opacity: 0, transformOrigin: '50% 50%'})
                .to(this.$refs.outline, {duration: 1, opacity: 1, scale: 1, transformOrigin: '50% 50%', ease: 'Power1.easeInOut'}, 0)
                .to(this.$refs.outline, {duration: 1, opacity: 0, scale: 0.95, transformOrigin: '50% 50%', ease: 'Power1.easeInOut'}, 1)
                .to(this.$refs.outline, {duration: 1, opacity: 1, scale: 1, transformOrigin: '50% 50%', ease: 'Power1.easeInOut'}, 2)
                .to(this.$refs.outline, {duration: 1, opacity: 0, scale: 0.95, transformOrigin: '50% 50%', ease: 'Power1.easeInOut'}, 3)
                .to(this.$refs.outline, {duration: 1, opacity: 1, scale: 1, transformOrigin: '50% 50%', ease: 'Power1.easeInOut'}, 4);
        }
    }
};
</script>
<style lang="scss" scoped>
.shield {
    svg {
        display: block;
        margin: 0 auto;
    }
}
</style>
